export default "__VITE_ASSET__B3Q4PNJr__"